import { MonitoringContext } from 'context/monitoring';
import { useContextSelector } from 'use-context-selector';

export function useSelectEfetivo() {
  const handleSelectEfetivo = useContextSelector(
    MonitoringContext,
    context => context.handleSelectEfetivo
  );

  return {
    handleSelectEfetivo,
  };
}

